import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Checkbox } from 'semantic-ui-react';
import { GPItem } from './add_gp/GPItem';
import { GPSearchDrawer } from './GPSearchDrawer';
export function GPProfileField({ value: yogp, onChange, edit }) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const hasGP = !!yogp;
    const isChecked = hasGP || isDrawerOpen;
    const handleCheckboxChange = (_e, { checked }) => {
        if (checked) {
            setIsDrawerOpen(true);
        }
        else {
            onChange(null);
        }
    };
    const handleSelect = (gp) => {
        onChange(gp);
        setIsDrawerOpen(false);
    };
    if (!edit) {
        return hasGP ? (_jsx(GPItem, { isSelected: false, selectedGP: yogp })) : (_jsx("p", { className: "text grey", children: "No doctor details saved" }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Checkbox, { label: "Yes, I would like to send my regular doctor information about any scripts issued following my consultation", checked: isChecked, onChange: handleCheckboxChange }), hasGP && (_jsxs(_Fragment, { children: [_jsx(GPItem, { isSelected: true, selectedGP: yogp }), _jsx("div", { className: "flex mt-2", children: _jsx(Button, { type: "button", primary: true, onClick: () => setIsDrawerOpen(true), children: "Change" }) })] })), _jsx(GPSearchDrawer, { selectedGP: yogp, open: isDrawerOpen, title: "Search by doctor's name or clinic name", onChange: handleSelect, onCancel: () => setIsDrawerOpen(false), showSaveCheckbox: false })] }));
}
